import { render, staticRenderFns } from "./PbcPlay.vue?vue&type=template&id=aea09ca0&"
import script from "./PbcPlay.vue?vue&type=script&lang=js&"
export * from "./PbcPlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports